import Button from "@/Components/Button/Button";
import { useSetModal } from "@/shared/atoms/useModal";
import useId from "@/shared/hooks/useId";
import { useTranslation } from "react-i18next";

const MapTablesEmpty = () => {
  const mapId = useId();
  const setModal = useSetModal();
  const { t } = useTranslation("", { keyPrefix: "maps" });
  return (
    <div className="flex h-full flex-col justify-center">
      <div className="mb-[1rem]">{t("emptyTablesDescription")}</div>
      <Button onClick={() => setModal("table", { mapId })}>
        {t("addTable")}
      </Button>
    </div>
  );
};

export default MapTablesEmpty;
